module.exports = __webpack_public_path__ + "img/i8.f02e9e8d.png";